import { Radio as DefaultRadio } from 'antd';
import styled from '@emotion/styled';

const { Group } = DefaultRadio;

const RadioGroup = styled(Group)`
  display: flex;
  align-items: center;
`;

const Radio = styled(DefaultRadio)`
  display: inline-flex;
  align-items: center;
`;

Radio.Group = RadioGroup;

export default Radio;
